import React, { useEffect, useState } from 'react';
import exampleTable from '../../../static/images/example_1.png';
import exampleImg from '../../../static/images/example_2.png';
import styles from '../modal/modal.module.scss';

function ModalComponent(props: any) {

    useEffect(() => {

    })

    return (
        <>
            {
                props.data ? <div className={styles.modalContent} dangerouslySetInnerHTML={{ __html: props.data }}></div> :
                    <div className={styles.modalContent}>
                        <div className={styles.exampleTitle}>卫健委截图样例</div>
                        <img src={exampleTable} alt='' width='100%' />
                        <div className={styles.exampleTitle}>胸牌样例</div>
                        <img src={exampleImg} alt='' width='100%' />
                        <div className={styles.content}>
                            <strong>照片内容以及格式要求</strong>
                            <div>1、照片或截图不得涂改，需确保完整、文字、图片、个人信息清晰可辨<br />
                                2、申请人真实姓名和证件号码与提交的证件信息一致<br />
                            </div>
                        </div>
                        <div className={styles.content}>
                            <strong>说明</strong>
                            <div>上传的证件照片只作验证医生真实身份使用。我们绝不会泄露您的证件信息，请您放心！</div>
                        </div>
                    </div>
            }
        </>
    )

}

export default ModalComponent;